export enum CONFIRMATION_DIALOG_TONE {
  DEFAULT = 'default',
  WARNING = 'warning',
  DESTRUCTIVE = 'destructive',
}
